import { Button, Card, Col, DatePicker, Form, Input, Row, Select, Switch } from 'antd';
import React from 'react';
import { statusOptions } from '../components/ProceedingStatus/ProceedingStatusConstants';
import { typeOptions } from './ProceedingType/ProceedingTypeConstants';

const { RangePicker } = DatePicker;

interface SearchComponentProps {
  onSearch: (values: any) => void;
  onReset: () => void;
  onCancel: () => void;
  form: any;
}

const SearchComponent: React.FC<SearchComponentProps> = ({ onSearch, onReset, onCancel, form }) => {
  const handleFinish = (values: any) => {
    if (values.hearingStartDate && values.hearingStartDate.length === 2) {
      const [from, to] = values.hearingStartDate;
      values.hearingStartDate = {
        from: from.toISOString(),
        to: to.toISOString(),
      };
    }

    onSearch(values);
  };

  return (
    <Card style={{ marginBottom: '10px' }} className="card">
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              name="proceedingId"
              label="Proceeding ID"
              rules={[
                {
                  pattern: /^\d+$/,
                  message: 'Only numeric values are allowed!',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="partyName" label="Party Name">
              <Input placeholder="Enter individual's name" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="hearingStartDate" label="Hearing Start Date">
              <RangePicker style={{ width: '100%' }} placeholder={['From', 'To']} />
            </Form.Item>
          </Col>

          <Col span={6}></Col>
        </Row>

        <Row gutter={16}>
          <Col span={6}>
            <Form.Item name="status" label="Proceeding Status">
              <Select options={statusOptions} allowClear />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="proceedingType" label="Proceeding Type">
              <Select options={typeOptions} allowClear />
            </Form.Item>
          </Col>

          <Col span={6}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Form.Item
                name="isJoint"
                label="Joint Hearing"
                valuePropName="checked"
                style={{ marginBottom: 0 }}
              >
                <Switch />
              </Form.Item>

              <div
                style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', width: 'auto' }}
              >
                <Button data-testid="searchBtnOnProcList" type="primary" htmlType="submit">
                  Search
                </Button>
                <Button onClick={onReset}>Reset</Button>
                <Button onClick={onCancel}>Cancel</Button>
              </div>
            </div>
          </Col>

          <Col span={6}></Col>
        </Row>
      </Form>
    </Card>
  );
};

export default SearchComponent;
